class Authority {

    constructor() {
        this.role = 'Tenant';
    }

    static getDisplayNameKey() {
        return 'name';
    }

    static getAuthoritynameKey() {
        return 'identifier';
    }

    static getRoleKey() {
        return 'role';
    }

    static getStatusKey() {
        return 'status';
    }

    static getRoleOptions() {
        return [
            { label: 'Administrator', value: 'Administrator' },
            { label: 'Tenant', value: 'Tenant' },
            { label: 'Built-in Administrator', value: 'Built-in Administrator' },
        ];
    }

    static getStatusOptions() {
        return [
            { label: 'Active', value: '1' },
            { label: 'Inactive', value: '0' },
        ];
    }

    static fromRaw(raw) {
        let authority = new Authority();
        authority.authorityname = raw.email;
        authority.uuid = raw.uuid;
        authority.loginTime = raw.lastLogin;
        authority.name = raw.name;
        authority.email = raw.email;
        authority.role = raw.type;
        authority.status = raw.status;

        return authority;
    }

    toRaw() {
        return {
            uuid: this.uuid,
            name: this.name,
            authorityname: this.authorityname,
            email: this.email,
            role: this.role,
            password: this.password,
            oldPassword: this.oldPassword,
            status: this.status,
            roleUuid: this.roleId
        }
    }

    static getAdminRole() {
        return 'Built-in Administrator';
    }
}

module.exports = Authority;


// WEBPACK FOOTER //
// ./src/azurebackup/model/Authority.js